import { Suspense } from 'react';
import { useTracking } from 'react-tracking';
import { ErrorBoundary } from '@sentry/react';

import { Alert, AlertAction } from '@simplywallst/ui-core';
import { NarrativeCardLoading } from '@/components/NarrativeCard';

import { NarrativeCommunitySpotlightList } from './components/NarrativeCommunitySpotlightList';

export const NarrativeCommunitySpotlight = () => {
  const { Track } = useTracking({
    type: 'track',
    subject: 'narrative_community_spotlight',
  });

  return (
    <Track>
      <ErrorBoundary
        fallback={
          <Alert
            styleType="negative"
            actions={
              <AlertAction onClick={() => window.location.reload()}>
                Reload
              </AlertAction>
            }
          >
            Failed to load narratives. Please try again.
          </Alert>
        }
      >
        <Suspense
          fallback={
            <section className="my-x2 grid w-full gap-x1 sm:gap-x2">
              <h2 className="m-0 text-sm font-medium text-solid">
                Weekly Picks
              </h2>
              <div
                className="grid grid-cols-[repeat(3,317px)] gap-x1 overflow-hidden"
                role="presentation"
                aria-label="Loading skeleton"
              >
                <NarrativeCardLoading showCompanyIcon />
                <NarrativeCardLoading showCompanyIcon />
                <NarrativeCardLoading showCompanyIcon />
              </div>
            </section>
          }
        >
          <NarrativeCommunitySpotlightList />
        </Suspense>
      </ErrorBoundary>
    </Track>
  );
};
